import { Injectable , Inject} from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType , HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';
import {DataService} from "../services/data.service";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

	token : any ;

    constructor(
	  	private http: HttpClient,
	    private _data : DataService,
		  @Inject('API_URL') public API_URL: any 
  	){
	      this.token = this._data.getCookiesByName('token');
	      console.log(this.token);
  	}


  	getAllNotification(data , type){
  		return this.http.post<any>(`${this.API_URL}/notification/?filter=${type}` , data)
	        .pipe(map(res => {
	            return res;
        }));
  	}
	  

  	markAsRead(notificationId){
  		return this.http.post<any>(`${this.API_URL}/bulk/notification/read/${notificationId}` , null)
	        .pipe(map(res => {
	            return res;
        }));
  	}

  	registerDeviceId(deviceId){
  		return this.http.put<any>(`${this.API_URL}/notification/subscribe/${deviceId}` , null)
	        .pipe(map(res => {
	            return res;
        }));
  	}
	  getBulkNotification(data ){
		return this.http.post<any>(`${this.API_URL}/bulk/notification` , data)
		  .pipe(map(res => {
			  return res;
	  }));
	}
	markBulkNotifAsRead(notificationId){
		return this.http.post<any>(`${this.API_URL}/bulk/mark/notification/${notificationId}` , null)
		  .pipe(map(res => {
			  return res;
	  }));
	}
	// download(batchId: number | undefined): Observable<Blob>{
	// 	return this.http.get<any>(`${this.API_URL}/bulk/notification/export/${batchId}`,{responseType:'blob'})
	// 	  .pipe(map(res => {
	// 		  return res;
	//   }));
	  download(batchId: number | undefined): Observable<Blob> {
		return this.http.get(`${this.API_URL}/bulk/notification/export/${batchId}`, {
		  responseType: 'blob'
		});
	  }
	
}
